import $ from 'jquery'
// import React from 'react-dom';
// import ReactDOM from 'react-dom';
import moment from 'moment'
import config from 'store/_config'
import _, { forEach } from 'lodash'
import { axiosInstance as axios, handleAxiosErrors, breakListIntoChunks, floorToTwoDecimals } from '_utils'
import {
  toggleCocktailLoading,
  convertCocktailsListToAReadableFormat,
  convertCocktailToAReadableFormat,
} from '../actions/cocktailsActions'
import {
  combineProductIDsWithCartQuantity,
  hasFiltersSelected,
  getProductsFullInfo,
} from '../selectors/defaultSelectors'
import { createAlert } from '../../main/dom/window'
import {
  convertProductsPricesToAReadableFormat,
  convertPoductTemplateToAReadableFormat,
  convertPoductNotificationToAReadableFormat,
  convertCategoriesToAReadableFormat,
  convertHasCocktailsToAReadableFormat,
  convertIsNewArrivalToAReadableFormat,
  convertIsSpecialToAReadableFormat,
  convertProductListingCategories,
  convertProductListingFilters,
  convertProductListingStateFilters,
  convertProductsListingToAReadableFormat,
  convertPromotionsListingToAReadableFormat,
  convertProductsAllocationToAReadableFormat,
  convertCocktailNotificationToAReadableFormat,
  convertCocktailTemplateToAReadableFormat,
} from '../selectors/productSelectors'
import { segmentTrackProductViewed } from '../utils/segment/ecommerce'
import { setUserCredentials, setDiscountSyncing } from '../actions/userActions'
import { updateCartItemProduct } from './cartActions'
import { updateCartList } from './cartSupplierActions'
import { requestProductDeals } from './promoDealsActions'
import { setPromoDealsSync } from './dealBuilderActions'
import { OrderTemplateFilter, toggleDiscountPriceLoading, togglePriceLoading } from './orderTemplateActions'
import { buildRequestProductListParams } from '../../main/selectors/defaultSelectors'
import { setItemInStorageWithExpiry, getItemFromStorageWithExpiry } from '../store/localStorage'
// import React from 'react';

let requestProductPriceQueue = {}
let timeout = {}

export const toggleProductsLoading = (value) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'TOGGLE_PRODUCTS_LOADING',
      value: value,
    })
  }
}
export const toggleProductTemplateLoading = (value) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'TOGGLE_PRODUCTS_TEMPLATE_LOADING',
      value: value,
    })
  }
}
export const toggleAllProductPriceLoading = (value) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'TOGGLE_FULL_PRODUCT_PRICES_LOADING',
      value: value,
    })
  }
}
export const toggleProductsFullLoading = (value) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'TOGGLE_PRODUCTS_FULL_LOADING',
      value: value,
    })
  }
}
export const toggleProductPromotionsLoading = (value) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'TOGGLE_PRODUCT_PROMOTIONS_LOADING',
      value: value,
    })
  }
}
export const toggleProductCocktailsLoading = (value) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'TOGGLE_PRODUCT_COCKTAILS_LOADING',
      value: value,
    })
  }
}
export const toggleProductReplacementsLoading = (value) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'TOGGLE_PRODUCT_REPLACEMENTS_LOADING',
      value: value,
    })
  }
}
export const setNewArrivalList = (list) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'SET_NEW_ARRIVAL_LIST',
      list: list,
    })
  }
}
export const setOnSpecialList = (list) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'SET_ON_SPECIAL_LIST',
      list: list,
    })
  }
}
export const updateOrderTemplate = (list) => {
  return {
    type: 'UPDATE_ORDER_TEMPLATE',
    list: _.keyBy(list, 'id'),
  }
}
export const initializeSelectedFilters = () => {
  return (dispatch, getState) => {
    if (typeof window.brand != 'undefined') {
      dispatch(applyInitializedFilters('Brand', window.brand))
    }
    if (typeof window.country != 'undefined') {
      dispatch(applyInitializedFilters('Country', window.country))
    }
    if (typeof window.region != 'undefined') {
      dispatch(applyInitializedFilters('Region', window.region))
    }
  }
}
export const applyInitializedFilters = (type, value) => {
  return (dispatch, getState) => {
    const state = getState()
    const { filters } = state.products
    const finalValue = decodeURI(value)

    let newFilters = {
      ...filters,
      ...{
        [type]: {
          [finalValue]: {
            id: finalValue,
            value: finalValue,
            checked: true,
          },
        },
      },
    }

    dispatch(updateProductsFilters(newFilters))
  }
}

export const trackProductViewed = () => {
  return (dispatch, getState) => {
    const state = getState()

    const productList = state.products.list

    const productID = window?.productID

    if (productID) {
      const productsFullInfo = getProductsFullInfo(productList, state)
      segmentTrackProductViewed(productsFullInfo[productID])
    }
  }
}

// promotions
export const updatePromotionProducts = (list) => {
  return {
    type: 'UPDATE_PROMOTION_PRODUCTS',
    list: _.keyBy(list, 'id'),
  }
}
export const requestProductPromotions = (params) => {
  return (dispatch, getState) => {
    const state = getState()
    // const { category } = state.products;
    const { key, base_group } = state.user
    let { url } = config.products.promotions
    url = url.replace(/{groupID}/, base_group).replace(/{productID}/, params.product)

    dispatch(toggleProductPromotionsLoading(true))

    return axios
      .get(url, {
        withCredentials: true,
        headers: {
          Authorization: key,
        },
      })
      .then((response) => {
        const { data } = response

        if (typeof data.status != 'undefined' && data.status == 0) {
          dispatch(toggleProductPromotionsLoading(false))
          createAlert(data, 'error')
        } else {
          const promotions = convertPromotionsListingToAReadableFormat(data)
          dispatch(updateProductPromotions(promotions, params.variation))
          dispatch(toggleProductPromotionsLoading(false))
        }
      })
      .catch((error) => handleAxiosErrors(error))
  }
}
export const updateProductPromotions = (list, product) => {
  return {
    type: 'UPDATE_PROMOTIONS_LIST',
    product: product,
    list: _.keyBy(list, 'id'),
  }
}

// cocktails
export const requestProductCocktails = (params) => {
  return (dispatch, getState) => {
    let { url, query } = config.cocktails.listing
    dispatch(toggleProductCocktailsLoading(true))
    return axios
      .post(url, {
        withCredentials: true,
        variables: {
          ProductID: params.productid,
        },
        query: query,
      })
      .then((response) => {
        const cocktails = convertCocktailsListToAReadableFormat(response.data.data.readCocktails.edges)
        dispatch(updateProductCocktails(cocktails, params.productid))
        dispatch(toggleProductCocktailsLoading(false))
      })
      .catch((error) => handleAxiosErrors(error))
  }
}
export const updateProductCocktails = (list, product) => {
  return {
    type: 'UPDATE_COCKTAILS_LIST',
    product: product,
    list: _.keyBy(list, 'id'),
  }
}
export const requestCocktail = (cocktail) => {
  return (dispatch, getState) => {
    const cocktailModal = document.getElementById('cocktail-modal')
    let { url, query } = config.cocktails.details
    $(cocktailModal).modal('show')
    dispatch(selectCocktail(cocktail))
    dispatch(toggleCocktailLoading(true))

    return axios
      .post(url, {
        withCredentials: true,
        variables: {
          ID: cocktail,
        },
        query: query,
      })
      .then((response) => {
        const items = convertCocktailToAReadableFormat(response.data.data.readOneCocktail)
        const productIDs = items[0].products.map((item) => item.productID)
        Promise.all([
          dispatch(updateProductCocktails(items, cocktail)),
          dispatch(requestProductsByIDs({ products: items[0].products })),
          dispatch(requestProductsTemplateCocktail(productIDs, items[0].products)),
          dispatch(requestProductsNotificationCocktail(productIDs, items[0].products)),
        ]).then(() => {
          dispatch(toggleCocktailLoading(false))
        })
      })
      .catch((error) => handleAxiosErrors(error))
  }
}
export const selectCocktail = (cocktail) => {
  return {
    type: 'SELECT_COCKTAIL',
    cocktail: cocktail,
  }
}

// replacements
export const requestProductReplacements = (params) => {
  return (dispatch, getState) => {
    const state = getState()
    // const { category } = state.products;
    const { list } = state.products
    const backOrderList = state.backorder.list
    const { product } = params

    let { url, query } = config.products.replacements

    let variables = {}
    if (typeof list[product] != 'undefined') {
      const { qty_per_case } = list[product]

      let minimumRequestedUnits = 0
      if (backOrderList[product] !== undefined && backOrderList[product]) {
        if (backOrderList[product].case !== undefined) {
          minimumRequestedUnits += Number(qty_per_case * backOrderList[product].case.TotalUnitItems)
        }

        if (backOrderList[product].unit !== undefined) {
          minimumRequestedUnits += Number(backOrderList[product].unit.TotalUnitItems)
        }
      }

      variables = {
        ProductID: product,
        TotalUnitItems: minimumRequestedUnits || 1,
        limit: 6,
      }
    }

    dispatch(toggleProductReplacementsLoading(true))
    dispatch(toggleProductTemplateLoading(true))

    return axios
      .post(url, {
        query: query,
        variables: variables,
      })
      .then((response) => {
        const products = convertProductsListingToAReadableFormat(response.data.data.readSubstituteProducts.edges)
        const categories = convertProductListingCategories(response.data.data.readSubstituteProducts.edges)

        // Get product IDs to request price
        const productIDs = products.map((item) => item.productID)
        Promise.all([
          dispatch(updateProductReplacements(products, product)),
          dispatch(updateProductsList(products)),
          // dispatch(updateCategories(categories)),
          dispatch(requestProductsTemplate(productIDs, products)),
          dispatch(requestProductsNotification(productIDs, products)),
          dispatch(requestProductsPrices(productIDs, products)),
        ]).then(() => {
          dispatch(toggleProductReplacementsLoading(false))
          dispatch(toggleProductTemplateLoading(false))
        })
      })
      .catch((error) => handleAxiosErrors(error))
  }
}
export const updateProductReplacements = (list, product) => {
  return {
    type: 'UPDATE_REPLACEMENTS_LIST',
    product: product,
    list: _.keyBy(list, 'id'),
  }
}

// filters
export const toggleActiveFilters = (flag) => {
  return {
    type: 'TOGGLE_ACTIVE_FILTERS',
    value: flag,
  }
}
export const toggleFilter = (params) => {
  return (dispatch, getState) => {
    const state = getState()
    const { key, id } = params
    let filters = state.products.filters
    const finalFilterValues = {
      ...filters,
      [key]: {
        ...filters[key],
        [id]: {
          ...filters[key][id],
          checked: !filters[key][id].checked,
        },
      },
    }

    dispatch({
      type: 'TOGGLE_FILTER',
      value: finalFilterValues,
    })

    dispatch({
      type: 'TOGGLE_ACTIVE_FILTERS',
      value: hasFiltersSelected(finalFilterValues),
    })
  }
}
export const clearFiltersByCategory = (category) => {
  return (dispatch, getState) => {
    const state = getState()
    const filters = state.products.filters
    const target = filters[category]
    Object.values(target).map((item, idnex) => {
      item.checked = false
    })

    dispatch({
      type: 'TOGGLE_FILTER',
      value: {
        ...filters,
        [category]: target,
      },
    })
  }
}
export const updateProductsFilters = (filters) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'SET_PRODUCTS_FILTERS',
      value: filters,
    })
  }
}
export const appendProductsFilters = (filters) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'APPEND_PRODUCTS_FILTERS',
      value: filters,
    })
  }
}

// products
// export const getCategoryID = () => {
//     return (dispatch, getState) => {
//         if (!window.categoryID) return;
//         dispatch({
//             type: 'SET_ACTIVE_CATEGORY',
//             category: categoryID
//         });
//     };
// };
// export const requestProductByID = (product, index, callback) => {
//     return (dispatch, getState) => {
//         const state = getState();
//         const { user, base_group, key } = state.user;
//         let { url } = config.products.details;
//         url = url.replace('{user}', user).replace('{base_group}', base_group).replace('{key}', key).replace('{productID}', product);
//
//         return axios.get(url, {
//             withCredentials: true,
//             headers: {
//                 Authorization: key
//             },
//         }).then((response) => {
//             const products = convertProductsListingToAReadableFormat(response.data.hits.hits, state.user);
//             const categories = convertProductListingCategories(response.data.hits.hits, state.user);
//             dispatch(updateProductsList(products));
//             dispatch(updateCategories(categories));
//             if (callback) dispatch(callback(products, index));
//         }).catch(error => handleAxiosErrors(error));
//     };
// };

export const requestProductsByIDs = (params = {}, callback) => {
  return (dispatch, getState) => {
    const state = getState()
    const uniqueProductIDs = params.products.filter(function (item, i, ar) {
      return item && item !== 'null' && ar.indexOf(item) === i
    }) // make sure it's unique so we don't waste space

    let { url, query } = config.products.details
    return axios
      .post(
        url,
        {
          query: query,
          variables: {
            IDs: uniqueProductIDs.map((ID) => Number(ID)),
          },
        },
        {
          withCredentials: true,
        }
      )
      .then((response) => {
        handleProductResponse(dispatch, state, params, response, callback)
      })
      .catch((error) => handleAxiosErrors(error))

    // params.products.forEach((item, index) => {
    //     dispatch(requestProductByID(item, index, callback));
    // });
  }
}

export const requestProductsSaleQuote = (params = {}, callback) => {
  return (dispatch, getState) => {
    const state = getState()
    const uniqueProductIDs = params.products.filter(function (item, i, ar) {
      return item && item !== 'null' && ar.indexOf(item) === i
    }) // make sure it's unique so we don't waste space

    let { url, query } = config.products.details
    return axios
      .post(
        url,
        {
          query: query,
          variables: {
            IDs: uniqueProductIDs.map((ID) => Number(ID)),
          },
        },
        {
          withCredentials: true,
        }
      )
      .then((response) => {
        const products = convertProductsListingToAReadableFormat(response.data.data.readProducts.edges, false)
        dispatch(updateProductsList(products))
        if (callback) {
          callback(products)
        }
      })
      .catch((error) => handleAxiosErrors(error))
  }
}

export const requestProductsByVariationIDs = (params, callback) => {
  return (dispatch, getState) => {
    const state = getState()
    const uniqueProductVariationIDs = params.products.filter(function (item, i, ar) {
      return item && item !== 'null' && ar.indexOf(item) === i
    }) // make sure it's unique so we don't waste space

    if (!uniqueProductVariationIDs?.length) {
      return
    }

    const productVariationIDs = uniqueProductVariationIDs.join('_')
    let { url } = config.products.detailsByVariationID
    url = url.replace('{productIDs}', productVariationIDs)

    return axios
      .get(url, {
        // withCredentials: true,
        // headers: {
        //     Authorization: key
        // },
      })
      .then((response) => {
        handleProductResponse(dispatch, state, params, response, callback)
      })
      .catch((error) => handleAxiosErrors(error))
  }
}
export const handleProductResponse = (dispatch, state, params, response, callback) => {
  const loadPriceSeparately = typeof params.loadPriceSeparately != 'undefined' ? params.loadPriceSeparately : true
  const processFilter = typeof params.processFilter != 'undefined' ? params.processFilter : false
  const products = convertProductsListingToAReadableFormat(response.data.data.readProducts.edges, state.user)
  const categories = convertProductListingCategories(response.data.data.readProducts.edges, state.user)
  // Get product IDs to request price
  const productIDs = products.map((item) => item.productID)
  let requestPromises = [dispatch(updateProductsList(products))]
  // TODO: Check if this is necessary
  if (!loadPriceSeparately) {
    requestPromises.push(dispatch(requestProductsPrices(productIDs, products)))
    // requestPromises.push(dispatch(requestProductRules(products)))
  }

  // TODO: Check if this is necessary
  if (processFilter) {
    const filters = convertProductListingFilters(response.data.hits.hits, state.user)
    requestPromises.push(dispatch(appendProductsFilters(filters)))
  }

  return Promise.all(requestPromises).then(() => {
    if (loadPriceSeparately) {
      dispatch(requestProductsPrices(productIDs, products))
      dispatch(requestProductRules(products))
    }
    // if(categories){
    //   dispatch(updateCategoriesOrderTemplate(categories))
    // }
    // TODO: Check if this is necessary
    dispatch(requestCategoryNames(Object.keys(categories)))
    dispatch(requestProductHasCocktails(productIDs))
    // dispatch(requestProductHasSpecials());
    // dispatch(requestProductIsNewArrival());
    // dispatch(togglePriceLoading(false))
    if (callback) {
      callback(products)
    }
  })
}
export const requestRequiredProductInformation = (productIDs, products) => {
  return (dispatch, getState) => {
    const state = getState()

    if (productIDs && productIDs?.length > 0) {
      let requestingCategories = {}
      Object.entries(state.products.list).map(([key, item]) => {
        const { categories } = item

        categories.map((categoryID) => {
          requestingCategories[categoryID] = categoryID
        })
      })

      const filters = convertProductListingStateFilters(Object.values(state.products.list), state.user)
      dispatch(appendProductsFilters(filters))

      // dispatch(requestCategoryNames(Object.keys(requestingCategories)));

      dispatch(requestProductsPrices(productIDs, products))
      // dispatch(requestProductHasCocktails(productIDs));
      // dispatch(requestProductHasSpecials());
      // dispatch(requestProductIsNewArrival());
    }
  }
}
export const requestProductsList = (params) => {
  return (dispatch, getState) => {
    const state = getState()
    // const { category } = state.products;
    const { startingIndex, amount } = params
    const category = window.categoryID
    const { user, base_group, key } = state.user
    let { url } = config.products.listing

    const currentStartingIndex = typeof startingIndex != 'undefined' ? startingIndex : 0
    const currentAmount = typeof amount != 'undefined' ? amount : 300
    url = url
      .replace('{user}', user)
      .replace('{base_group}', base_group)
      .replace('{key}', key)
      .replace('{category}', category)
      .replace('{startingIndex}', currentStartingIndex)
      .replace('{amount}', currentAmount)

    if (currentStartingIndex == 0) {
      dispatch(toggleProductsLoading(true))
    }

    dispatch(toggleProductsFullLoading(true))

    return axios
      .get(url, {
        // withCredentials: true,
        // headers: {
        //     Authorization: key
        // },
      })
      .then((response) => {
        const totalRecords = response.data.hits.total
        const totalRequestedRecords = currentStartingIndex + currentAmount
        const products = convertProductsListingToAReadableFormat(response.data.hits.hits, state.user)
        const categories = convertProductListingCategories(response.data.hits.hits, state.user)
        const filters = convertProductListingFilters(response.data.hits.hits, state.user)

        // Get product IDs to request price
        const productIDs = products.map((item) => item.productID)

        // const productFiltersResolve = currentStartingIndex == 0 ? dispatch(updateProductsFilters(filters)) : dispatch(appendProductsFilters(filters));
        const productFiltersResolve = dispatch(appendProductsFilters(filters))

        // wait for async requests
        Promise.all([
          dispatch(updateProductsList(products)),
          productFiltersResolve,
          // dispatch(updateCategories(categories)),
        ]).then(() => {
          dispatch(toggleProductsFullLoading(false))
          dispatch(requestProductsPrices(productIDs, products))
          dispatch(requestProductHasCocktails(productIDs))

          if (currentStartingIndex == 0) {
            dispatch(toggleProductsLoading(false))
            // dispatch(requestProductHasSpecials());
            // dispatch(requestProductIsNewArrival());

            if (totalRecords > totalRequestedRecords) {
              dispatch(requestProductsList({ startingIndex: totalRequestedRecords - 1, amount: totalRecords }))
            }
          }
        })
      })
      .catch((error) => handleAxiosErrors(error))
  }
}
export const requestFeaturedList = (params, type) => {
  return (dispatch, getState) => {
    const state = getState()
    // const { category } = state.products;
    const { startingIndex, amount } = params
    const category = window.categoryID
    const { user, base_group, key } = state.user
    let axiosConfig = {}
    let url = ''

    if (type == 'New Arrivals') {
      url = config.products.newArrival.url
    } else {
      url = config.products.onSpecials.url
      axiosConfig = {
        ...axiosConfig,
        withCredentials: true,
        headers: {
          Authorization: key,
        },
      }
    }

    const currentStartingIndex = typeof startingIndex != 'undefined' ? startingIndex : 0
    const currentAmount = typeof amount != 'undefined' ? amount : 300
    url = url
      .replace('{user}', user)
      .replace('{base_group}', base_group)
      .replace('{key}', key)
      .replace('{category}', category)
      .replace('{startingIndex}', currentStartingIndex)
      .replace('{amount}', currentAmount)

    if (currentStartingIndex == 0) {
      dispatch(toggleProductsLoading(true))
    }

    dispatch(toggleProductsFullLoading(true))

    return axios
      .get(url, axiosConfig)
      .then((response) => {
        const { data } = response

        if (typeof data.status != 'undefined' && data.status == 0) {
          const { status, message } = data

          dispatch(toggleProductsLoading(false))
          dispatch(toggleProductsFullLoading(false))

          if (status && message) {
            createAlert(data, 'success')
          } else if (!status && message) {
            createAlert(data, 'error')
          }
        } else {
          if (typeof response.data.hits != 'undefined' && typeof response.data.hits.total != 'undefined') {
            const totalRecords = response.data.hits.total
            const totalRequestedRecords = currentStartingIndex + currentAmount
            const products = convertProductsListingToAReadableFormat(response.data.hits.hits, state.user)
            const categories = convertProductListingCategories(response.data.hits.hits, state.user)
            const filters = convertProductListingFilters(response.data.hits.hits, state.user)

            // Get product IDs to request price
            const productIDs = products.map((item) => item.productID)

            const productFiltersResolve =
              currentStartingIndex == 0
                ? dispatch(updateProductsFilters(filters))
                : dispatch(appendProductsFilters(filters))

            // wait for async requests
            Promise.all([
              dispatch(updateProductsList(products)),
              dispatch(updateFeaturedList(products)),
              productFiltersResolve,
              // dispatch(updateCategories(categories)),
            ]).then(() => {
              dispatch(toggleProductsFullLoading(false))
              dispatch(requestProductsPrices(productIDs, products))
              dispatch(requestProductHasCocktails(productIDs))

              // dispatch(requestProductHasSpecials());
              // dispatch(requestProductIsNewArrival());

              if (currentStartingIndex == 0) {
                dispatch(toggleProductsLoading(false))

                if (totalRecords > totalRequestedRecords) {
                  dispatch(
                    requestFeaturedList({ startingIndex: totalRequestedRecords - 1, amount: totalRecords }, type)
                  )
                }
              }
            })
          } else {
            dispatch(toggleProductsLoading(false))
            dispatch(toggleProductsFullLoading(false))
          }
        }
      })
      .catch((error) => handleAxiosErrors(error))
  }
}
export const requestProductIDTimestamp = (callback) => {
  return (dispatch, getState) => {
    const state = getState()
    const productList = state.products.list
    // const { category } = state.products;
    const category = window.categoryID
    // const { user, base_group, key } = state.user;
    let { url } = config.products.idtimestamp
    const now = moment()

    url = url.replace('{category}', category)

    dispatch(toggleProductsLoading(true))

    return axios
      .get(url, {
        withCredentials: true,
        // headers: {
        //     Authorization: key
        // },
      })
      .then((response) => {
        const { data } = response
        let requestingProductIDs = []
        let requestingAdditionalInfoOfExistingProductIDs = []

        // Convert to list with product ID as key
        const productsBasedOnProductID = {}
        Object.entries(productList).map(([key, item]) => {
          const { productID } = item
          productsBasedOnProductID[productID] = item
        })

        // Now check
        Object.entries(data).map(([id, timestamp]) => {
          let doRequest = true

          if (typeof productsBasedOnProductID[id] != 'undefined') {
            const { lastEdited, case_price, expiredOn } = productsBasedOnProductID[id]

            // Check if the timestamp with the server is different
            if (case_price != null && lastEdited == timestamp) {
              doRequest = false
            }

            // Check if it means to be expired
            if (typeof expiredOn == 'undefined' || now > expiredOn) {
              doRequest = true
            }
          }

          if (doRequest) {
            requestingProductIDs.push(id)
          } else {
            requestingAdditionalInfoOfExistingProductIDs.push(id)
          }
        })

        // Also request information that does not belong to those products
        Promise.all([
          dispatch(requestRequiredProductInformation(requestingAdditionalInfoOfExistingProductIDs, productList)),
        ]).then(() => {
          dispatch(toggleProductsFullLoading(true))

          // Break the request into every 700
          let promisedValues = []
          const chunkedList = breakListIntoChunks(requestingProductIDs, 700)

          chunkedList.map((chunkedProductIDs) => {
            promisedValues.push(
              dispatch(
                requestProductsByIDs({ products: chunkedProductIDs, processFilter: true }, (products) => {
                  dispatch(toggleProductsLoading(false))
                })
              )
            )
          })

          // Request Products
          Promise.all(promisedValues).then(() => {
            dispatch(toggleProductsFullLoading(false))
          })
        })
      })
      .catch((error) => handleAxiosErrors(error))
  }
}
export const markOnSpecialProducts = (onSpecialsData, productList) => {
  // DEPRECATED
  return (dispatch, getState) => {
    const products = convertIsSpecialToAReadableFormat(onSpecialsData, productList)
    dispatch(updateProductsList(products))
  }
}
export const requestProductHasSpecials = () => {
  // DEPRECATED
  return (dispatch, getState) => {
    const state = getState()

    if (state.products.onSpecialList != null) {
      dispatch(markOnSpecialProducts(state.products.onSpecialList, state.products.list))
    } else {
      return axiosRequestProductHasSpecials(state)
        .then((response) => {
          const { data } = response

          if (Array.isArray(data) && data.length == 0) {
            dispatch(setOnSpecialList([]))
          } else {
            dispatch(markOnSpecialProducts(data, state.products.list))
            dispatch(setOnSpecialList(data))
          }
        })
        .catch((error) => handleAxiosErrors(error))
    }
  }
}
export const axiosRequestProductHasSpecials = (state) => {
  // DEPRECATED

  // const { category } = state.products;
  const { key } = state.user
  let { url } = config.products.onSpecialsIDOnly

  return axios.get(url, {
    withCredentials: true,
    headers: {
      Authorization: key,
    },
  })
}
export const markNewArrivalProducts = (newArrivalData, productList) => {
  // DEPRECATED
  return (dispatch, getState) => {
    const products = convertIsNewArrivalToAReadableFormat(newArrivalData, productList)
    dispatch(updateProductsList(products))
  }
}
export const requestProductIsNewArrival = () => {
  // DEPRECATED
  return (dispatch, getState) => {
    const state = getState()

    if (state.products.newArrivalList != null) {
      dispatch(markNewArrivalProducts(state.products.newArrivalList, state.products.list))
    } else {
      return axiosRequestProductIsNewArrival(state)
        .then((response) => {
          const { data } = response

          dispatch(markNewArrivalProducts(data, state.products.list))
          dispatch(setNewArrivalList(data))
        })
        .catch((error) => handleAxiosErrors(error))
    }
  }
}
export const axiosRequestProductIsNewArrival = (state) => {
  // DEPRECATED
  // const { category } = state.products;
  const { key } = state.user
  let { url } = config.products.newArrivalIDOnly

  return axios.get(url, {
    // withCredentials: true,
    // headers: {
    //     Authorization: key
    // },
  })
}

export const axiosRequestEnCustomerDiscounts = (state, memberId) => {
  let memberID = 0

  if (state?.supplier?.activeCustomer?.id) {
    memberID = state.supplier.activeCustomer.id
  } else if (window?.placeOnBehalfOfID > 0) {
    memberID = window.placeOnBehalfOfID
  }

  if (memberId) {
    memberID = memberId
  }

  const { url, query } = config.products.enCustomerDiscounts

  let variables = {}

  if (memberID) {
    variables['MemberID'] = parseInt(memberID, 10)
  }

  return axios.post(url, {
    query,
    variables,
  })
}

export const axiosRefreshEnCustomerDiscounts = (memberID) => {
  const { url, query } = config.products.refreshEnCustomerDiscounts

  let variables = {}

  if (memberID) {
    variables['MemberID'] = parseInt(memberID, 10)
  }

  return axios.post(url, {
    query,
    variables,
  })
}

/**
 * Due to pollingDiscountSyncing function could be triggered multiple times
 * We have to clear the interval
 */
const pollingDiscountSyncing = (list, products, blockID) => {
  return (dispatch, getState) => {
    const state = getState()

    dispatch(setDiscountSyncing(true))
    dispatch(togglePriceLoading(true))

    if (window.pollingAxios) {
      clearInterval(window.pollingAxios)
    }

    async function pollingAxios() {
      try {
        const memberID = parseInt(state.user.user, 10)
        const enCustomerDiscountsDataResponse = await axiosRequestEnCustomerDiscounts(state, memberID)
        const discountSyncing = !!enCustomerDiscountsDataResponse?.data?.data?.readEnCustomerDiscounts
          ?.IsDiscountSyncing
        const customerPromo = JSON.parse(
          enCustomerDiscountsDataResponse?.data?.data?.readEnCustomerDiscounts?.Discounts
        )
        const promoDeals = JSON.parse(enCustomerDiscountsDataResponse?.data?.data?.readEnCustomerDiscounts?.PromoDeals)

        if (discountSyncing === false) {
          clearInterval(window.pollingAxios)

          dispatch(setDiscountSyncing(false))
          // await dispatch(togglePriceLoading(false))

          await dispatch(
            setUserCredentials({
              customerPromo,
              promoDeals,
              discountSyncing,
            })
          )

          const state = getState()
          const productList = state.products.list

          const productIDs = Object.keys(productList)
          const products = Object.values(productList)
          await dispatch(requestProductsPrices(productIDs, products, blockID))
          dispatch(requestProductsTemplate(productIDs, products))
          dispatch(requestProductsNotification(productIDs, products))
          // await dispatch(togglePriceLoading(false))
        }
      } catch (error) {
        handleAxiosErrors(error)
      }
    }

    window.pollingAxios = setInterval(pollingAxios, 3000, state)
  }
}

export const getCustomerPromo = (list, products, blockID) => {
  return async (dispatch, getState) => {
    const state = getState()

    let customerPromo = {}
    let promoDeals = {}
    dispatch(togglePriceLoading(true))
    console.log('state.user.use', state.user.use)
    try {
      const memberID = parseInt(state.user.user, 10)
      const enCustomerDiscountsDataResponse = await axiosRequestEnCustomerDiscounts(state, memberID)
      customerPromo = JSON.parse(enCustomerDiscountsDataResponse?.data?.data?.readEnCustomerDiscounts?.Discounts)
      promoDeals = JSON.parse(enCustomerDiscountsDataResponse?.data?.data?.readEnCustomerDiscounts?.PromoDeals)
      const discountSyncing = !!enCustomerDiscountsDataResponse?.data?.data?.readEnCustomerDiscounts?.IsDiscountSyncing
      // const discountSyncing = true
      let discountSyncingInProcess
      if (!discountSyncing && (customerPromo.length === 0 || customerPromo.length !== 0)) {
        discountSyncingInProcess = true
        dispatch(
          setUserCredentials({
            discountSyncingInProcess,
          })
        )
      }

      if (discountSyncing === true) {
        dispatch(pollingDiscountSyncing(list, products, blockID))
      } else {
        await dispatch(
          setUserCredentials({
            customerPromo,
            promoDeals,
            discountSyncing,
            discountSyncingInProcess,
          })
        )
        return customerPromo
        // await dispatch(togglePriceLoading(false))
        // await dispatch(togglePriceLoading(false))
      }
    } catch (error) {
      handleAxiosErrors(error)
      return
    }
  }
}

export const requestProductsPrices = (list, products, blockID, memberID) => {
  return async (dispatch, getState) => {
    const store = getState()
    let chargeAreaID = store?.user?.chargeArea || 0
    let isTarget
    const enCustomerDiscountsDataResponse = await axiosRequestEnCustomerDiscounts(store, memberID)
    const discountSyncingFetch = !!enCustomerDiscountsDataResponse?.data?.data?.readEnCustomerDiscounts
      ?.IsDiscountSyncing
    // if (Object.keys(customerPromo).length === 0) {
    //   dispatch(getCustomerPromo(list, products, blockID))
    // }

    const customerPromo = await dispatch(getCustomerPromo(list, products, blockID, memberID))
    if (!discountSyncingFetch) {
      //   dispatch(togglePriceLoading(true))
      const chunkedList = breakListIntoChunks(list, 700)
      if (list.length == 0) {
        dispatch(togglePriceLoading(false))
      }
      await Promise.all(
        chunkedList.map(async (chunkedProductIDs) => {
          const compiledProductIDs = chunkedProductIDs
          if (compiledProductIDs && compiledProductIDs?.length > 0) {
            const memberID = parseInt(store.user.user, 10)
            const response = await axiosRequestProcessedProductsPrices(compiledProductIDs, memberID)
            const productPrices = convertProductsPricesToAReadableFormat(response.data.data.readProductPrices, false)
            const mergedProducts = _.map(products, function (item) {
              return _.merge(item, _.find(productPrices, { id: item.id }))
            })

            let _products = []
            mergedProducts.forEach((p) => {
              const {
                id,
                sku,
                wetTax,
                unit_price,
                case_price,
                qty_per_case,
                wholesale_unit_per_case,
                splitCaseSurchargesJSON,
              } = p
              let surcharge = splitCaseSurchargesJSON[chargeAreaID] || {}
              let promoListSize = 0
              if (customerPromo) {
                promoListSize = Array.isArray(customerPromo)
                  ? customerPromo?.length
                  : Object.keys(customerPromo)?.length
              }
              // const target = customerPromo && customerPromo[sku]
              if (promoListSize > 0 && customerPromo && customerPromo[sku]) {
                isTarget = true
                _products.push({
                  BuyableID: id,
                  CasePrice: case_price ? case_price * (1 + wetTax) : 0,
                  UnitPrice: (unit_price - customerPromo[sku]['CalculatedUnitDiscount']) * (1 + wetTax),
                  // Discount: customerPromo[sku]['CalculatedDiscount1'] * (1 + wetTax),
                  Discount: customerPromo[sku]['CalculatedDiscount1'],
                  DiscountedCasePrice: case_price
                    ? (case_price - customerPromo[sku]['CalculatedCaseDiscount']) * (1 + wetTax)
                    : 0,
                  FrontLineCasePrice: case_price ? case_price : 0,
                  SupplierDiscountPerCase:
                    customerPromo[sku] && customerPromo[sku]['CalculatedCaseDiscount2']
                      ? floorToTwoDecimals(customerPromo[sku]['CalculatedCaseDiscount2'])
                      : 0.0,
                  WetTax: wetTax,
                  QtyPerCase: qty_per_case,
                  WholesaleUnitsPerCase: wholesale_unit_per_case,
                  Featured: customerPromo[sku] && customerPromo[sku]['Featured'] ? customerPromo[sku]['Featured'] : 0,
                  unitSurcharge: surcharge?.Rate,
                })
              } else {
                _products.push({
                  BuyableID: id,
                  CasePrice: case_price ? case_price * (1 + wetTax) : 0,
                  UnitPrice: unit_price ? unit_price * (1 + wetTax) : 0,
                  Discount: 0,
                  DiscountedCasePrice: case_price ? case_price * (1 + wetTax) : 0,
                  FrontLineCasePrice: case_price ? case_price : 0,
                  QtyPerCase: qty_per_case,
                  WholesaleUnitsPerCase: wholesale_unit_per_case,
                  // SupplierDiscountPerCase:
                  //   customerPromo && customerPromo[sku] && customerPromo[sku]['CalculatedCaseDiscount2']
                  //     ? floorToTwoDecimals(customerPromo[sku]['CalculatedCaseDiscount2'])
                  //     : 0.0,
                  SupplierDiscountPerCase: 0.0,
                  WetTax: wetTax,
                  // Featured: customerPromo && customerPromo[sku] && customerPromo[sku]['Featured'] ? customerPromo[sku]['Featured'] : 0,
                  Featured: 0,
                  unitSurcharge: surcharge?.Rate,
                })
              }
            })

            const _redo = convertProductsPricesToAReadableFormat(_products, false)
            if (blockID) {
              await dispatch(updateProductsScrollableList(_redo, blockID))
              dispatch(updateProductsList(_redo))
              dispatch(requestProductDeals())
            } else {
              dispatch(updateProductsList(_redo))
              dispatch(requestProductDeals())
              dispatch(OrderTemplateFilter())
              dispatch(togglePriceLoading(false))
            }
          }
        })
      )
    }
  }
}
export const setProductsRulesList = (list) => {
  return {
    type: 'SET_PRODUCTS_RULES_LIST',
    list: list,
  }
}

export const requestProductRules = () => {
  return async (dispatch, getState) => {
    const store = getState()

    // Get Product rules from local storage and use it until its expired
    let rulesInStorage = getItemFromStorageWithExpiry('productRules', window.currentMemberID)

    // console.log("rulesInStorage ==== requestProductRules" , {rulesInStorage})
    if (rulesInStorage) {
      let availableProductRules = rulesInStorage || []
      dispatch(setProductsRulesList(availableProductRules))
    } else {
      const memberID = parseInt(store.user.user, 10)
      let { url, query } = config.products.readProductAllocation
      axios
        .get(url, {
          params: {
            query: query,
          },
        })
        .then((response) => {
          // Storing product rules in local storage after API Call and set expriry of 15 minutes
          setItemInStorageWithExpiry(
            'productRules',
            window.currentMemberID,
            response?.data?.data?.readProductAllocation,
            15
          )

          let availableProductRules = response?.data?.data?.readProductAllocation
          dispatch(setProductsRulesList(availableProductRules))
        })
        .catch((error) => {
          handleAxiosErrors(error)
        })
    }
  }
}

export const requestProductsTemplateCocktail = (list, products, blockID, memberID) => {
  return async (dispatch, getState) => {
    const store = getState()
    const customerPromo = store.user.customerPromo

    if (Object.keys(customerPromo).length === 0) {
      dispatch(getCustomerPromo(list, products, blockID))
    }

    //Break the request into every 700
    const chunkedList = breakListIntoChunks(list, 700)

    await Promise.all(
      chunkedList.map(async (chunkedProductIDs) => {
        const compiledProductIDs = chunkedProductIDs

        if (compiledProductIDs && compiledProductIDs?.length > 0) {
          const memberID = parseInt(store.user.user, 10)
          const response = await axiosRequestProcessedProductsTemplate(compiledProductIDs, memberID)
          const products = convertCocktailTemplateToAReadableFormat(response.data.data.readOrderTemplate.edges, false)
          const productsIDS = products.reduce((items, product) => {
            items.push(product.id)
            return items
          }, [])

          let promisedRequests = []
          const chunkedList = breakListIntoChunks(productsIDS, 100)

          chunkedList.map((chunkedProductIDs) => {
            promisedRequests.push(
              dispatch(
                requestProductsByIDs({ products: chunkedProductIDs }, (products) => {
                  /**
                   * Got some redundant product ID from readOrderTemplate
                   * Need to update product in the order template after readProducts
                   */
                  const responseProducts = products.map((x) => {
                    return {
                      id: parseInt(x.id, 10),
                      isAddToTemplate: true,
                    }
                  })

                  dispatch(updateProductsList(responseProducts))
                  dispatch(OrderTemplateFilter())
                })
              )
            )
          })
        }
      })
    )
  }
}
export const requestProductsTemplate = (list, products, blockID, memberID) => {
  return async (dispatch, getState) => {
    const chunkedList = breakListIntoChunks(list, 900)

    chunkedList.map((chunkedProductIDs) => {
      const state = getState()

      axiosRequestProcessedProductsTemplate(chunkedProductIDs, memberID)
        .then((response) => {
          const { data } = response
          const products = convertPoductTemplateToAReadableFormat(
            response.data.data.readOrderTemplate.edges,
            state.user,
            state.products.list
          )

          dispatch(updateProductsList(products))
        })
        .catch((error) => handleAxiosErrors(error))
    })
  }
}

export const requestProductsNotificationCocktail = (list, products, blockID, memberID) => {
  return async (dispatch, getState) => {
    const store = getState()

    const customerPromo = store.user.customerPromo

    if (Object.keys(customerPromo).length === 0) {
      dispatch(getCustomerPromo(list, products, blockID))
    }

    //Break the request into every 700
    const chunkedList = breakListIntoChunks(list, 700)

    await Promise.all(
      chunkedList.map(async (chunkedProductIDs) => {
        const compiledProductIDs = chunkedProductIDs

        if (compiledProductIDs && compiledProductIDs?.length > 0) {
          const memberID = parseInt(store.user.user, 10)

          // Get Remind me Products from local storage and use it until its expired
          let productsInStorage = getItemFromStorageWithExpiry('remindMeProducts', window.currentMemberID)

          //Check to trigger read remind me products API on page load when product added or removed in remind me products
          let isRemindProductChanged = JSON.parse(
            localStorage.getItem('isRemindProductChanged' + window.currentMemberID)
          )

          let remindMeProductsData = []

          if (!isRemindProductChanged && productsInStorage) {
            remindMeProductsData = productsInStorage
          } else {
            const response = await axiosRequestProcessedProductsNotification(compiledProductIDs, memberID)

            // Storing remind Me Products in local storage after API Call and set expriry of 15 minutes
            setItemInStorageWithExpiry(
              'remindMeProducts',
              window.currentMemberID,
              response.data.data.readRemindMeProducts,
              15
            )

            //Don't trigger read remind me products API every time page loads after product added or removed in remind me products
            localStorage.setItem('isRemindProductChanged' + window.currentMemberID, false)

            remindMeProductsData = response.data.data.readRemindMeProducts
          }

          const products = convertCocktailNotificationToAReadableFormat(remindMeProductsData, false)
          const productsIDS = products.reduce((items, product) => {
            items.push(product.id)
            return items
          }, [])

          console.log(productsIDS)
          // if (productsIDS.length !== 0) {
          let promisedRequests = []
          const chunkedList = breakListIntoChunks(productsIDS, 100)

          chunkedList.map((chunkedProductIDs) => {
            promisedRequests.push(
              dispatch(
                requestProductsByIDs({ products: chunkedProductIDs }, (products) => {
                  /**
                   * Got some redundant product ID from readOrderTemplate
                   * Need to update product in the order template after readProducts
                   */
                  const responseProducts = products.map((x) => {
                    return {
                      id: parseInt(x.id, 10),
                      isNotify: true,
                    }
                  })
                  console.log('after notify')
                  console.log(responseProducts)

                  dispatch(updateProductsList(responseProducts))
                })
              )
            )
          })
          // }
        }
      })
    )
  }
}
export const requestProductsNotification = (list, products, blockID, memberID) => {
  return async (dispatch, getState) => {
    const state = getState()

    // Get Remind me Products from local storage and use it until its expired
    let productsInStorage = getItemFromStorageWithExpiry('remindMeProducts', window.currentMemberID)

    //Check to trigger read remind me products API on page load when product added or removed in remind me products
    let isRemindProductChanged = JSON.parse(localStorage.getItem('isRemindProductChanged' + window.currentMemberID))

    if (!isRemindProductChanged && productsInStorage) {
      const products = convertPoductNotificationToAReadableFormat(productsInStorage, state.user, state.products.list)
      dispatch(updateProductsList(products))
    } else {
      const chunkedList = breakListIntoChunks(list, 900)

      chunkedList.map((chunkedProductIDs) => {
        axiosRequestProcessedProductsNotification(chunkedProductIDs, memberID)
          .then((response) => {
            // Storing remind Me Products in local storage after API Call and set expriry of 15 minutes
            setItemInStorageWithExpiry(
              'remindMeProducts',
              window.currentMemberID,
              response.data.data.readRemindMeProducts,
              15
            )

            //Don't trigger read remind me products API every time page loads after product added or removed in remind me products
            localStorage.setItem('isRemindProductChanged' + window.currentMemberID, false)

            const products = convertPoductNotificationToAReadableFormat(
              response.data.data.readRemindMeProducts,
              state.user,
              state.products.list
            )

            dispatch(updateProductsList(products))
          })
          .catch((error) => handleAxiosErrors(error))
      })
    }
  }
}

export const addToNotify = (product) => {
  return (dispatch, getState) => {
    let { url, query } = config.products.notificationToggle
    return axios
      .post(url, {
        query: query,
        variables: {
          ProductID: product.id,
          RemindMe: true,
        },
      })
      .then((response) => {
        if (response) {
          createAlert({ message: 'Item successfully added.' }, 'success')
          dispatch(setProductIsNotifyStatus(product.id, true))
          dispatch(requestProductDeals())

          //Check to trigger read remind me products API on page load when product added or removed in remind me products
          localStorage.setItem('isRemindProductChanged' + window.currentMemberID, true)

          return true
        }
        createAlert({}, 'error')
        return false
      })
      .catch((error) => handleAxiosErrors(error))
  }
}

export const removeFromNotify = (product) => {
  return (dispatch, getState) => {
    let { url, query } = config.products.notificationToggle

    return axios
      .post(url, {
        query: query,
        variables: {
          ProductID: product.id,
          RemindMe: false,
        },
      })
      .then((response) => {
        if (response) {
          createAlert({ message: 'Item successfully Removed' }, 'success')
          dispatch(setProductIsNotifyStatus(product.id, false))
          dispatch(requestProductDeals())

          //Check to trigger read remind me products API on page load when product added or removed in remind me products
          localStorage.setItem('isRemindProductChanged' + window.currentMemberID, true)

          return true
        }
        createAlert({}, 'error')
        return false
      })
      .catch((error) => handleAxiosErrors(error))
  }
}

export const setProductIsNotifyStatus = (ID, status) => {
  console.log(ID)
  return (dispatch, getState) => {
    const state = getState()
    const productList = state.products.list
    if (typeof productList[ID] != 'undefined') {
      const updatedList = {
        [ID]: {
          id: ID,
          isNotify: status,
        },
      }
      console.log('update list')
      console.log(updatedList)

      dispatch(updateProductsList(updatedList))
    }
  }
}

export const axiosRequestProcessedProductsNotification = (chunkedProductIDs, memberID, zoneID = 0) => {
  let { url, query } = config.products.notificationListing

  return axios.get(url, {
    withCredentials: true,
    params: {
      query,
    },
  })
}

export const axiosRequestProcessedProductsTemplate = (chunkedProductIDs, memberID, zoneID = 0) => {
  let { url, query } = config.orderTemplate.listing

  return axios.get(url, {
    withCredentials: true,
    params: {
      query,
    },
  })
}

export const axiosRequestProcessedProductsPrices = (chunkedProductIDs, memberID, zoneID = 0, showLoad = false) => {
  let { url, query } = config.products.prices

  let finalProductIDs = [...chunkedProductIDs].filter((productID) => productID !== null)

  const variables = {
    BuyableIDs: finalProductIDs,
  }

  if (memberID) {
    variables['MemberID'] = parseInt(memberID, 10)
  }

  if (zoneID) {
    // If zoneID is passed, fetch pricing based on ZoneID instead of MemberID
    variables['ZoneID'] = parseInt(zoneID, 10)
    delete variables['MemberID']
  }

  return axios.post(url, {
    query,
    variables,
  })
}

export const requestProductHasCocktails = (list) => {
  return (dispatch, getState) => {
    // TODO: Let's try to deprecate below
    return ''

    // Break the request into every 900
    const chunkedList = breakListIntoChunks(list, 900)

    chunkedList.map((chunkedProductIDs) => {
      const state = getState()

      if (chunkedProductIDs.length > 0) {
        axiosRequestProductHasCocktails(state, chunkedProductIDs)
          .then((response) => {
            const { data } = response

            if (data.status) {
              const products = convertHasCocktailsToAReadableFormat(data.products, state.products.list)
              dispatch(updateProductsList(products))
            } else {
              createAlert(data)
            }
          })
          .catch((error) => handleAxiosErrors(error))
      }
    })
  }
}
export const axiosRequestProductHasCocktails = (state, chunkedProductIDs) => {
  let { url, query } = config.products.hasCocktails
  // url = url.replace('{user}', user).replace('{base_group}', base_group).replace('{key}', key).replace('{category}', category);

  return axios.post(url, {
    query: query,
    variables: {
      IDs: chunkedProductIDs,
    },
  })
}
export const requestCategoryNames = (categoryIDs) => {
  return (dispatch, getState) => {
    // TODO: Probably we have to remove this
    return

    let { url } = config.categories.listNames
    url = url.replace('{ids}', categoryIDs.join('_'))

    return axios
      .get(url, {
        // withCredentials: true,
      })
      .then((response) => {
        const categories = convertCategoriesToAReadableFormat(response.data.categories)
        dispatch(updateCategories(categories))
      })
      .catch((error) => handleAxiosErrors(error))
  }
}
export const updateProductsList = (list) => {
  return {
    type: 'UPDATE_PRODUCTS_LIST',
    list: _.keyBy(list, 'id'),
  }
}

export const updateProductsScrollableList = (list, blockID) => {
  return {
    type: 'UPDATE_PRODUCTS_SCROLLABLE_LIST',
    list: _.keyBy(list, 'id'),
    blockID: blockID,
  }
}

export const updateProductsListUnsort = (list) => {
  return {
    type: 'UPDATE_PRODUCTS_LIST',
    list,
  }
}

export const updateFeaturedList = (list) => {
  return {
    type: 'UPDATE_FEATURED_LIST',
    list: _.keyBy(list, 'id'),
  }
}
export const updateCategories = (list) => {
  return {
    type: 'UPDATE_CATEGORIES_LIST',
    list: _.keyBy(list, 'id'),
  }
}

export const updateCategoriesOrderTemplate = (list) => {
  return {
    type: 'UPDATE_CATEGORIES_LIST_ORDER_TEMPLATE',
    list: _.keyBy(list, 'id'),
  }
}

export const removeProductsList = (list) => {
  return {
    type: 'REMOVE_PRODUCTS_LIST',
    list: _.keyBy(list, 'id'),
  }
}
export const handleTabs = (row, key, table) => {
  const { viewIndex, original } = row
  const { id } = original
  const { tabsSelected } = table.state
  const tabKey = key === 'product' ? 'hasBackOrder' : key
  const target = `${tabKey}-${id}`
  let newTabsSelected = {
    [id]: tabsSelected[id] !== target ? target : false,
  }
  let newExpanded = {
    [viewIndex]: tabsSelected[id] !== target ? {} : false,
  }

  // reset
  if (key === 'product' && tabsSelected[id]) {
    newTabsSelected = {
      [id]: false,
    }
    newExpanded = {
      [viewIndex]: false,
    }
  }

  table.handleTabs({ newTabsSelected, newExpanded })
}

export const handleTransBinTabs = (row, key, table) => {
  const { viewIndex, original } = row
  const { expanded } = table.state
  let newExpanded = {}
  if (expanded[viewIndex]) {
    newExpanded[viewIndex] = false
  } else {
    Object.keys(expanded).forEach((key) => {
      expanded[key] = false
    })
    newExpanded[viewIndex] = {}
  }

  table.handleTabs({ newExpanded })
}

export const requestProductListingGrid = (params) => {
  return (dispatch, getState) => {
    const state = getState()
    const prevList = state?.products?.loyaltyBox?.list || []
    let { url, query } = config.products.listing

    query = query.replace(
      /{params}/,
      buildRequestProductListParams({
        BlockID: parseInt(params.BlockID) || 0,
        limit: parseInt(params?.itemsLimit) || 3,
      })
    )
    dispatch(updateProductLoyaltyBox('isLoading', true))

    return axios
      .get(url, {
        params: {
          query: query,
        },
      })
      .then((response) => {
        const list = convertProductLoyaltyBoxListToReactFormat(response.data, params.BlockID)
        dispatch(addProductsToGrid(list))
      })
      .catch((error) => {
        createAlert({ message: error.message }, 'error')
      })
      .then((response) => {
        dispatch(updateProductLoyaltyBox('isLoading', false))
      })
  }
}

export const convertProductLoyaltyBoxListToReactFormat = (list, blockID) => {
  list = list?.data?.searchResult?.edges || []
  if (list.length > 0) {
    return list.map((product) => {
      product = product?.node?.[0]
      return {
        id: product?.ID,
        title: product?.Title,
        image: product?.ReSizedProductListingImage,
        description: product?.LiquorStyle,
        blockID: blockID,
      }
    })
  }
  return []
}

export const updateProductLoyaltyBox = (key, value) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'UPDATE_PRODUCT_GRID_DETAILS',
      key: key,
      value: value,
    })
  }
}

export const addProductsToGrid = (list) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'ADD_PRODUCT_GRID_LIST',
      value: list,
    })
  }
}

export function getProductsByBlockID(blockID, list) {
  return list.filter((product) => product.blockID == blockID)
}

export function convertLoyaltyBoxProductsToReact(data = '[]') {
  const list = data !== undefined ? JSON.parse(data) : []
  return list?.Columns || []
}

export const toggleLoyaltyProductPopup = (toggle, product) => {
  return (dispatch, getState) => {
    dispatch(updateProductLoyaltyBox('showProductModal', toggle))
    dispatch(updateProductLoyaltyBox('activeProduct', convertLoyaltyProductToReact(product)))
  }
}

export const convertLoyaltyProductToReact = (product) => {
  console.log('Prodsdfdfd', product)
  return product?.PopUp?.[0] || null
}
